"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _radioButtonModule = _interopRequireDefault(require("./radioButton.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = function RadioButton(props) {
  var label = props.label,
      id = props.id,
      onChange = props.onChange,
      disabled = props.disabled,
      value = props.value,
      name = props.name,
      horizontal = props.horizontal,
      labelStyle = props.labelStyle,
      style = props.style,
      required = props.required;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    id: id ? id : null,
    key: id,
    className: (0, _classnames.default)(_themeModule.default.arag, horizontal ? _radioButtonModule.default['radioButtonHorizontalWrapper'] : _radioButtonModule.default['radioButtonWrapper'])
  }, horizontal ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("label", {
    id: id ? "".concat(id, "_radio_label") : null,
    style: labelStyle,
    htmlFor: id ? "".concat(id, "_radio_input") : null
  }, _react.default.createElement("span", null, label), _react.default.createElement("input", {
    type: "radio",
    id: id ? "".concat(id, "_radio_input") : null,
    checked: value === id,
    onChange: onChange,
    disabled: disabled,
    value: id,
    name: name,
    required: required,
    style: style
  }))) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("input", {
    type: "radio",
    id: id ? "".concat(id, "_radio_input") : null,
    checked: value === id,
    onChange: onChange,
    disabled: disabled,
    value: id,
    name: name,
    required: required,
    style: style
  }), _react.default.createElement("label", {
    htmlFor: id ? "".concat(id, "_radio_input") : null,
    id: id ? "".concat(id, "_radio_label") : null
  }, label))));
};

RadioButton.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String that specifies a value.*/
  value: _propTypes.default.string,

  /** String that specifies a name of input.*/
  name: _propTypes.default.string,

  /** Callback invoked on option select. An event argument will be available. eg: (evt) => {} */
  onChange: _propTypes.default.func,

  /** The selected option key */
  checked: _propTypes.default.bool.isRequired,

  /** The label attribute of the label tag */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.func]),

  /** Boolean indicating if the input is disabled */
  disabled: _propTypes.default.bool,

  /** Boolean indicating if the element is required */
  required: _propTypes.default.bool,

  /** Unique key property */
  key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Unique key property */
  horizontal: _propTypes.default.bool
};
var _default = RadioButton;
exports.default = _default;